
import React from 'react';
import { Button } from "@/components/ui/button";
import { Shield } from 'lucide-react';

export const AuditHeader: React.FC = () => {
  return (
    <div className="flex justify-between items-start">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Predictive Audit Triggers</h1>
        <p className="text-muted-foreground">
          Proactive monitoring system that identifies potential audit issues before they become compliance problems
        </p>
      </div>
      <div>
        <Button className="bg-audit-600 hover:bg-audit-700">
          <Shield className="mr-2 h-4 w-4" /> Create Custom Trigger
        </Button>
      </div>
    </div>
  );
};
